module.exports = __webpack_public_path__ + "static/media/about_portfolio4.c6fadc13.JPG";